import React from "react";
import {Link} from "react-router-dom";
//import React, { PureComponent } from "react";
import "./style.css";
import bg from '../../assets/images/background.svg';
import {get_NoiteDia} from '../../components/NoiteDia'

/*
class Error extends PureComponent {
  render() {
    return (
      <div className="erro">
        <span>página não encontrada</span>
      </div>
    );
  }
}

export default Error;
*/



export default function ErroX(props) {
  const { xSVG, text_aviso, text_description, text_btn } = props;

  return (
  <div className='erro-conteiner' >
    <div className="erro-x dj-bg" style={{ backgroundImage: `url(${bg})` }}>
      <img className="xSVG" src={xSVG} alt="" />
      <h1 className="text-n1 archivo-bold-color-text-54px">{text_aviso}</h1>
      <p className="text-n2 poppins-normal-color-text-16px">{text_description}</p>
      <Link className="boto djbtn" to='/planetas'>
        <div className="btn-txt valign-text-middle archivo-semi-bold-white-18px">{text_btn}</div>
      </Link>
    </div>
   </div>
  );
}

export function ErroAviso(props) {
  const { titulo, aviso, description, btn_text, btn_to, btn_OnClick, btns } = props;

  const root = document.documentElement;
  const modo_noite = get_NoiteDia()

  if (modo_noite) {
    //-dj//console.log("mudando para noite")
    root.style.setProperty("--color-background-erro", "var(--color-background-erro-black)")
    root.style.setProperty("--color-text", "var(--color-text-black)")
  } else {
    //-dj//console.log("mudando para dia")
    root.style.setProperty("--color-background-erro", "var(--color-background-erro-white)")
    root.style.setProperty("--color-text", "var(--color-text-white)")
  }

  return (
  <div className='erro-conteiner' >
    <div className="erro-x dj-bg" style={{ backgroundImage: `url(${bg})` }}>
      <h1 className="text_titulo valign-text-middle">{titulo}</h1>
      <h2 className="text-n1">{aviso}</h2>
      <p  className="text-n2">{description}</p>
      <div className="btns-conteiner">
        <Link className="boto djbtn" to={btn_to} onClick={btn_OnClick}>
          <div className="btn-txt valign-text-middle archivo-semi-bold-white-18px">{btn_text}</div>
        </Link>
        {btns}
      </div>
    </div>
   </div>
  );
}

export  function Error(props) {
    return(
        <div className="notifError">
            <h5>{props.error}</h5>
        </div>
    )
};
/*

djpop-alert
djpop-alert.success
djpop-alert.info
djpop-alert.warning
djpop-closebtn {
    padding
djpop-closebtn:hover
*/
//
// export  function AlertPopUp() {
//
//     const [alert, setAlert] = useState({
//         tipo: '',
//         text: '',
//         show: false
//     })
//
//     function onCloseAlert() {
//         setAlert({
//             tipo: '',
//             text: '',
//             show: false
//         })
//     }
//
//     function onShowAlert(text,tipo) {
//         setAlert({
//             text: text,
//             tipo: tipo||"default",
//             show: true
//         })
//     }
//
//     // const alert_tipos = ["default", "success", "info", "warning"]
//
//     const icons = {
//         default:<i className="fi-rr-exclamation"/>,
//         success:<i className="fi-rr-shield-check"/>,
//         info:<i className="fi-rr-info"/>,
//         warning:<i className="fi-rr-shield-exclamation"/>,
//         close:<i className="fi-rr-cross-circle"/>,
//     }
//
//     function Alert ({alert}) {
//         if (!alert.show) return <></>
//
//         return (
//             <div className={`djpop-alert ${alert.tipo}`}>
//                 <span className="djpop-closebtn" onclick={onCloseAlert}>{icons.close}</span>
//                 {icons[alert.tipo]}
//                 <p>{alert.text}</p>
//             </div>
//         )
//     }
//
//     return {Alert, alert, onShowAlert,onCloseAlert}
// };
